export default __webpack_public_path__ + "static/media/SpeechH1.c8c578dc.png";